export default{
    setSettings(state, payload) {
        state.settings = payload;
    },
    setPublicSettings(state, payload) {
        state.publicSettings = payload;
    },
}